"use client";

import { useState, useEffect, useRef } from "react";

export default function VideoSection() {
  const [shouldLoadVideo, setShouldLoadVideo] = useState(false);
  const videoRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !shouldLoadVideo) {
            setShouldLoadVideo(true);
          }
        });
      },
      { threshold: 0.1 }
    );
    const el = videoRef.current;
    if (el) observer.observe(el);
    return () => {
      if (el) observer.unobserve(el);
    };
  }, [shouldLoadVideo]);

  return (
    <section className="bg-white py-20">
      <div className="container mx-auto px-4">
        <h2 className="mb-12 text-center text-3xl font-bold text-gray-900">
          Ready to get Married?
        </h2>
        <div className="mx-auto max-w-5xl">
          <div className="relative mx-auto w-full max-w-4xl overflow-hidden rounded-xl bg-gray-900 shadow-2xl">
            <div
              ref={videoRef}
              className="relative h-0 w-full pb-[56.25%] bg-black"
            >
              {shouldLoadVideo ? (
                <iframe
                  src="https://www.youtube.com/embed/qojEvStgpNk?rel=0&modestbranding=1&showinfo=0&controls=1&mute=1&loading=lazy"
                  title="Marathi Vadhu Var Suchak Promo Video"
                  className="video-iframe absolute left-0 top-0 h-full w-full"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  loading="lazy"
                />
              ) : (
                <div className="absolute inset-0 flex items-center justify-center bg-gray-900">
                  <div className="text-center">
                    <svg
                      className="mx-auto mb-4 h-16 w-16 text-white opacity-75"
                      fill="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path d="M8 5v14l11-7z" />
                    </svg>
                    <p className="text-sm text-white">
                      Video will load when in view
                    </p>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
